<template lang="pug">
  #app
    header-component
    .contenedor
      .container.is-fluid.is-marginless.min-height-full
        transition(name="fade")
          router-view

    notifications        
</template>

<script>
  import HeaderComponent from './components/Header_Logged.vue'
  export default {
    components: {
      HeaderComponent
    },
    name: 'adminApp'
  }
</script>

<style lang="stylus">

  $yellow = #ffdd57

  #app {
    font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,Helvetica,Arial,sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    height: 100%
    background-color #f9f9f9
    overflow hidden
  }

  html, body {
    height: 100%
    margin 0
    font-size 14px
    overflow hidden
  }

  .slide-down-enter-active, .slide-down-leave-active {
    transition-property: max-height;
    transition-duration: .25s;
  }

  .slide-down-enter-active {
    transition-delay: .25s;
  }

  .slide-down-enter, .slide-down-leave-active {
    max-height: 0
  }

  .fade-enter-active, .fade-leave-active {
    transition-property: opacity;
    transition-duration: .25s;
  }

  .fade-enter-active {
    transition-delay: .25s;
  }

  .fade-enter, .fade-leave-active {
    opacity: 0
  }


  .fade-quick-enter-active, .fade-quick-leave-active {
    transition-property: opacity;
    transition-duration: .1s;
  }

  .fade-quick-enter-active {
    transition-delay: .1s;
  }

  .fade-quick-enter, .fade-quick-leave-active {
    opacity: 0
  }
  
  .fade-smooth-enter, .fade-smooth-leave-active {
    opacity: 0;
    transform: translateY(-10px);
  }

  .fade-smooth-leave-active {
    position: absolute;
  }

  .half-width
    width 50%
  
  .full-width
    width 100%
  
  .margin-auto
    margin auto
  
  .cursor
    cursor pointer
  
  .contenedor
    height 100%
    padding-top 52px
    
  .margin-top-10
    margin-top 10px
  
  .padding-20
    padding 20px
  
  .display-flex
    display flex
  
  .height-100
    height 100%

  .margin-bottom-0
    margin-bottom 0px !important
  
  .cursor-pointer
    cursor pointer !important
  
  .position-relative
    position: relative !important
  
  .flex-direction-column
    flex-direction: column !important
  
  .margin-top-5
    margin-top 5px !important
  
  .margin-left-5
    margin-left 5px !important
  
  .user-select-none
    user-select: none;
  
  .pagination
    display: flex;
    width: 100%;
    padding 10px
    .page
      flex 1
      margin 5px
  
  .uppercase
    text-transform:uppercase !important
  
  .padding-top-5
    padding-top 5px
  
  .input-with-button-right
    display flex
    .field
      margin-bottom 0
    input
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    .button
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
  
  .position-absolute
    position absolute !important
  
  .top-minus-6
    top: -6px !important
  
  .display-inline-block
    display inline-block !important

  .width-110
    width 110px
  
  .width-100
    width 100px

  .width-45
    width 45px    

  .padding-left-10
    padding-left 10px !important
  
  .flex-1
    flex 1 !important
  
  .margin-5
    margin 5px !important
  
  .align-items-center
    align-items center
  
  .margin-y-5
    margin 5px 0
  
  .margin-10
    margin 10px
  
  .font-size-11
    font-size 11px
  
  .width-75
    width 75px
  
  .width-111
    width 111px
  
  .min-height-full
    min-height 100%
  
  .button.is-very-small
    font-size: .65rem
  
  .padding-5
    padding 5px
  
  .button-excel
    background-color #0a6332
    color #fff

    &:hover
      background-color inherit
      color #0a6332

    &:active, &:focus
      background-color #0a6332
      color #fff  
  
  .margin-bottom-10
    margin-bottom 10px
  
  .font-size-12
    font-size: 12px;
  
  .margin-right-5
    margin-right 5px
  
  .min-height-100
    min-height 100px
  
  .width-175
    width 175px
  
  .margin-right-10
    margin-right 10px
  
  .padding-0
    padding 0px
  
  .margin-bottom-5
    margin-bottom 5px !important
  
  .width-113
    width: 113px;
  
</style>



// WEBPACK FOOTER //
// Admin_App.vue?068dc6c0